/* eslint-disable @typescript-eslint/naming-convention */
export const evaluationsText = ['qParent/evaluationText1', 'qParent/evaluationText2', 'qParent/evaluationText3'];

export const emojis = {
  '-1': 'assets/img/emojis/grey-emoji.png',
  0: 'assets/img/emojis/red-emoji.png',
  1: 'assets/img/emojis/yellow-emoji.png',
  2: 'assets/img/emojis/green-emoji.png'
};
